import { takeEvery, takeLatest } from 'redux-saga/effects';
import { GEOGRAPHY_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_ZONE_LIST,
  CREATE_ZONE,
  DELETE_ZONE,
  EDIT_ZONE_BY_ID,
  LOAD_ZONE_BY_ID,
  EXPORT_GEOGRAPHY,
  IMPORT_GEOGRAPHY,
  LOAD_ZONE_HISTORY,
  LOAD_HISTORY_BY_ID,
} from '../actions';

import loadGeographyList from './loadGeographyList';
import createGeography from './createGeography';
import loadGeographyById from './loadGeographyById';
import editGeographyById from './editGeographyById';
import deleteGeography from './deleteGeography';
import exportGeography from './exportGeography';
import importGeography from './importGeography';
import loadHistoryById from './loadHistoryById';
import loadGeographyHistory from './loadGeographyHistory';

export default function* watchDashboard() {
  yield takeLatest(GEOGRAPHY_MODULE + LOAD_ZONE_LIST, loadGeographyList);
  yield takeLatest(GEOGRAPHY_MODULE + CREATE_ZONE, createGeography);
  yield takeEvery(GEOGRAPHY_MODULE + LOAD_ZONE_BY_ID, loadGeographyById);
  yield takeEvery(GEOGRAPHY_MODULE + EDIT_ZONE_BY_ID, editGeographyById);
  yield takeEvery(GEOGRAPHY_MODULE + DELETE_ZONE, deleteGeography);
  yield takeEvery(GEOGRAPHY_MODULE + EXPORT_GEOGRAPHY, exportGeography);
  yield takeEvery(GEOGRAPHY_MODULE + IMPORT_GEOGRAPHY, importGeography);
  yield takeEvery(GEOGRAPHY_MODULE + LOAD_ZONE_HISTORY, loadGeographyHistory);
  yield takeEvery(GEOGRAPHY_MODULE + LOAD_HISTORY_BY_ID, loadHistoryById);
}
